import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ImageCompressorService {
  public compressImage(
    file: File,
    maximumDimensions: { height: number; width: number }
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onerror = (error) => reject(error);
      reader.onload = (event: any) => {
        const img = new Image(),
          dataUrl = event.target.result;
        img.src = dataUrl;
        img.onerror = (error) => reject(error);
        img.onload = () => {
          const elem = document.createElement('canvas');
          const width = img.width;
          const height = img.height;
          let scaleFactor = 1;
          let correctedMaximumDimensions = {
            width: maximumDimensions.width,
            height: maximumDimensions.height,
          };
          if (
            (width > height &&
              maximumDimensions.width < maximumDimensions.height) ||
            (height > width &&
              maximumDimensions.height < maximumDimensions.width)
          ) {
            correctedMaximumDimensions = {
              width: maximumDimensions.height,
              height: maximumDimensions.width,
            };
          }
          if (
            width > correctedMaximumDimensions.width ||
            height > correctedMaximumDimensions.height
          ) {
            if (width > correctedMaximumDimensions.width) {
              scaleFactor = correctedMaximumDimensions.width / width;
            } else {
              scaleFactor = correctedMaximumDimensions.height / height;
            }
          }
          const newHeight = height * scaleFactor;
          const newWidth = width * scaleFactor;
          elem.width = newWidth;
          elem.height = newHeight;
          const ctx = elem.getContext('2d');
          if (!ctx) {
            reject('Error getting context');
            return;
          }
          ctx.drawImage(img, 0, 0, newWidth, newHeight);
          const compressedDataUrl = ctx.canvas.toDataURL('image/webp');
          resolve(
            compressedDataUrl.length < dataUrl.length
              ? compressedDataUrl
              : dataUrl
          );
        };
      };
    });
  }
}
